export default __webpack_public_path__ + "static/media/EE.8a29d683.ico";